import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 60px;

  ${(props) =>
    props.compact &&
    `
    max-width: 300px;
  `}
`;

export const Content = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  ${(props) =>
    props.compact &&
    `
    flex-direction: column;
  `}

  @media (${tabletMax}) {
    flex-direction: column;
  }
`;

export const Column = styled.div<{ compact?: boolean }>`
  width: 100%;

  &:nth-child(1) {
    padding-right: 15px;
  }

  ${(props) =>
    !props.compact &&
    `  
    width: 50%;
    
    &:nth-child(2) {
      padding-left: 15px;
    }
  `}

  @media (${tabletMax}) {
    width: 100%;

    &:nth-child(2) {
      padding-left: 0;
      margin-top: 30px;
    }
  }
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 20px;
  color: ${(props) => props.theme.textDark};
  margin-bottom: 15px;
`;

export const Row = styled.div`
  display: flex;
  margin-top: 15px;
  align-items: flex-start;
`;

export const Icon = styled.div`
  width: 30px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SocialIcons = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: row;

  ${(props) =>
    props.compact &&
    `
    padding-left: 40px;
    margin-top: 10px;
  `}

  a {
    margin-right: 10px;
  }

  a:hover svg {
    color: ${(props) => props.theme.backgroundLight};
  }
`;
